import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/it-service.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="IT Service Package"
				subtitle=""
				breadcrumbText="IT Service Package"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}